/**
 * Privacy Policy 页 —— 直接渲染 src/content/policy.html
 * Vite 的 ?raw 后缀让 HTML 在 build 时编译进 bundle，SSG 友好（不走运行时 fetch）
 */
import policyHtml from '@/content/policy.html?raw';

export default function Page() {
  return (
    <div className="container" style={{ padding: '64px 24px', maxWidth: 800 }}>
      <h1 style={{ fontSize: 36, fontWeight: 700, marginBottom: 32 }}>Privacy Policy</h1>
      <div dangerouslySetInnerHTML={{ __html: policyHtml }} />
    </div>
  );
}
